// extracted by mini-css-extract-plugin
module.exports = {"container":"Board_container__10R5r","Main":"Board_Main__yNWk5","Text":"Board_Text__2_jqG"};